export const searchBar = function(searchBarContainer) {
	if (!searchBarContainer) return;
	const searchBarOpenBtn = document.querySelector('.header__search-bar-btn'),
		  searchBarCloseBtn = searchBarContainer.querySelector('.search-bar__close-btn'),
		  searchBarFields = searchBarContainer.querySelector('.search-bar__fields-wrapper'),
		  searchBarInput = searchBarContainer.querySelector('.search-bar__field'),
		  body = document.querySelector('body');

	searchBarOpenBtn.addEventListener('click', (e)=> {
		searchBarContainer.classList.add('search-bar--open');
		searchBarFields.classList.add('search-bar__fields-wrapper--open');
		body.classList.add('searchBarOpen');
		setTimeout(function () {
			searchBarInput.focus();
			searchBarInput.setSelectionRange(0, searchBarInput.value.length);
		}, 500);
	});

	searchBarCloseBtn.addEventListener('click', (e)=> {
		searchBarContainer.classList.remove('search-bar--open');
		searchBarFields.classList.remove('search-bar__fields-wrapper--open');
		body.classList.remove('searchBarOpen');
	});
}
